export enum FIELD_NAMES {
    START_TIME = "startTime",
    END_TIME = "endTime",
    NOTE = "note",
    TASK_TYPE = "taskType",
    PATIENT="patient",
    DURATION="duration",
    CREATED_DATE = "createdDate",
    PROFILE="profile"
  }